import md5 from 'js-md5'
import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'

let Base64 = require('js-base64').Base64;
/*-----------------jsencrypt加密函数--------------------*/
var key;
const publicKey = '-----BEGIN PUBLIC KEY-----\n' +
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDISG2RmPItrse4souoIJjk3CvK\n' +
  'cHLQi5+RWF+H+n2VUyXF2bkcL9FAAeCxx2MPEKDvdv+aBnFAzu+8GuTnLSo46MTK\n' +
  '65RkxTIZt/M6c3ef19dMJ0q3/Eo4dw1oPH4p1fSv1ctV1MphuSLAR29ZQnp1V7ib\n' +
  'v1xArkwNhx+/MY3pAQIDAQAB\n' +
  '-----END PUBLIC KEY-----';

function randomKey() {
  var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C',
    'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
    'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  var res = "";
  for (var i = 0; i < 16; i++) {
    var id = Math.ceil(Math.random() * 35);
    res += chars[id];
  }
  return res;
}

function Md5Sign(params, key, timestamp) {
  params['timestamp'] = timestamp;
  var my_sorted = Object.keys(params).sort();
  var joinStr = '';
  for (var _i in my_sorted) {
    joinStr += my_sorted[_i] + '=' + params[my_sorted[_i]] + '&';
  }
  var md5Str = md5(joinStr + key).toUpperCase();
  return md5Str
}

function EncryptRsa(data) {
  var encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  return encrypt.encrypt(data)
}

function EncryptAes(params, key) {
  var _key = CryptoJS.enc.Utf8.parse(key);//加密秘钥
  var iv = CryptoJS.enc.Utf8.parse(key);//矢量
  var srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(params));
  var encrypted = CryptoJS.AES.encrypt(srcs, _key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  var code = encrypted.ciphertext.toString().toUpperCase();
  return code
}

function DecryptAes(data, key) {
  var decrypted;
  var _key = CryptoJS.enc.Utf8.parse(key);
  var iv = CryptoJS.enc.Utf8.parse(key);
  let encryptedHexStr = CryptoJS.enc.Hex.parse(data);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, _key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  let s = decrypted = CryptoJS.enc.Utf8.stringify(decrypt);
  return JSON.parse(s)

}

function EncryptData(params) {
  if (typeof(params) != "object") {
    // console.error("params is not an object!");
    return false
  }
  key = randomKey();
  var timestamp = Math.round(new Date().getTime() / 1000).toString();
  var aesStr = EncryptAes(params, key);
  var sign = Md5Sign(params, key, timestamp);
  var securityKey = EncryptRsa(key);
  var obj = {
    timestamp: timestamp,//时间戳
    k: securityKey,//密文加秘钥
    a: aesStr,//接口字符串
    s: sign//签名
  }
  return obj
}

function EncryptBase64(value) {
  return Base64.encode(value)
}

function DecryptBase64(EncryptedValue) {
  return Base64.decode(EncryptedValue)
}

export {
  key,
  EncryptBase64,
  DecryptBase64,
  EncryptRsa,
  EncryptData
}
